import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { isFoundingListener } from '../../util/foundingListener';

import css from './FoundingListenerBadge.module.css';

const HeartIcon = () => (
  <svg
    className={css.heart}
    viewBox="0 0 16 16"
    width="11"
    height="11"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M8 13.6S2.4 10.2 1.3 7.3C.5 5.4 1.5 3.5 3.6 3.4c1.2-.1 2.2.6 2.7 1.6.5-1 1.5-1.7 2.7-1.6 2.1.1 3.1 2 2.3 3.9C13.6 10.2 8 13.6 8 13.6z"
    />
  </svg>
);

/**
 * Small blue "Founding Listener" pill. Hidden unless publicData.founding
 * is true on the listing or the listener user.
 *
 * @component
 * @param {Object} props
 * @param {Object} [props.user] listener user
 * @param {Object} [props.listing] listener listing
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @returns {JSX.Element|null}
 */
const FoundingListenerBadge = props => {
  const { user, listing, className, rootClassName } = props;
  const intl = useIntl();
  if (!isFoundingListener(listing) && !isFoundingListener(user)) {
    return null;
  }

  return (
    <span
      className={classNames(rootClassName || css.root, className)}
      data-founding-listener="true"
      title={intl.formatMessage({ id: 'FoundingListenerBadge.title' })}
    >
      <HeartIcon />
      <FormattedMessage id="FoundingListenerBadge.label" />
    </span>
  );
};

export default FoundingListenerBadge;
